var map = {
	"./en-US": [
		568,
		187
	],
	"./en-US.ts": [
		568,
		187
	],
	"./it-IT": [
		236,
		236
	],
	"./it-IT.ts": [
		236,
		236
	],
	"./zh-CN": [
		813,
		813
	],
	"./zh-CN.ts": [
		813,
		813
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 828;
module.exports = webpackAsyncContext;